export default __webpack_public_path__ + "static/media/KZ.6aa4f288.svg";